import short from "short-uuid";
export function shortId() {
  return short.generate();
}
